"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hillo = _interopRequireDefault(require("hillo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function fetchConfig() {
  return _fetchConfig.apply(this, arguments);
}

function _fetchConfig() {
  _fetchConfig = _asyncToGenerator(function* () {
    try {
      var response = yield fetch('/' + 'Resource/config/config.json');
      return yield response.json();
    } catch (e) {
      console.warn('no Config found');
      return {};
    }
  });
  return _fetchConfig.apply(this, arguments);
}

function resolveBestIP(_x) {
  return _resolveBestIP.apply(this, arguments);
}

function _resolveBestIP() {
  _resolveBestIP = _asyncToGenerator(function* (deviceId) {
    var res = yield _hillo.default.get('https://innerken.com/iplogger/', {
      op: 'findBestIp',
      deviceId: deviceId
    });
    return res.content;
  });
  return _resolveBestIP.apply(this, arguments);
}

var _default = {
  fetchConfig,
  resolveBestIP
};
exports.default = _default;